import styled, { css } from 'styled-components';
import { Col, Row } from '../../theme/libraries/grid';
import { rem } from 'polished';

export const ProductRow = styled(Row)`
  margin-bottom: ${rem(20)};
`;

/* Gallery and product meta share the row 50/50 from 1024 up; the visible gap
   between them is just the two grid col paddings (2×15px). Below 1024 both
   cols stack full-width. */
export const GalleryCol = styled(Col)`
  ${({ theme }) => theme.media(1024)} {
    width: ${({ theme }) => theme.grid.col.col6};
    position: relative;
  }
`;

export const ProductMetaCol = styled(Col)`
  ${({ theme }) => theme.media(1024)} {
    width: ${({ theme }) => theme.grid.col.col6};
  }
`;

export const ProductSmallThumbCol = css`
  flex: 0 0 ${rem(60)};
  padding-right: ${rem(15)};
  padding-left: 0;
`;

export const ProductSmallInfoCol = css`
  flex: 1 1 auto;
  overflow: hidden;
`;

export const ProductSmallPriceCol = css`
  flex: 1 1 1%;
  font-weight: 700;
  padding-right: 0;
  padding-left: ${rem(20)};
`;

export const ProductSmallName = css`
  margin: 0 0 ${rem(5)};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const ProductSmallAmount = css`
  color: ${({ theme }) => theme.color.gray66};
  margin: 0;
`;
